import React, {useEffect, useState} from "react";
import { collection, query, where, getDocs , doc, getDoc} from "firebase/firestore"; // Import necessary Firestore functions
import {db} from "../Firebase/firebase";
import bgLogoHole from "../Images/bg-logo-hole.png";
import goldenImage from "../Images/goldern group.png";
import whatsAppLogo from "../Images/whatsapp.png";
import telegramLogo from "../Images/telegramlogo.png";
import border from "../Images/border.jpeg";
import {Link} from "react-router-dom"
import SEO from "../components/SEO";
import SEOKeywords from "../components/SEOKeywords";


export default function MainPage(){
    const [draws, setDraws] = useState([]);
    const [delhiPatternDraws, setDelhiPatternDraws] = useState([]);
    const [mumbaiPatternDraws, setMumbaiPatternDraws] = useState([]);
    const [loading, setLoading] = useState(false);
    const [topSixMumbaiDraws, setTopSixMumbaiDraws] = useState([]);
    const [todaysDraws, setTodaysDraws] = useState([]);
    const [upcomingDraws, setUpcomingDraws] = useState([]);
    const [luckyNumbersList, setLuckyNumbersList] = useState([]);
    const [whatsappNumbersList, setWhatsAppNumbersList] = useState([]);
    const [config, setConfig] = useState({});
    const [highlightedDraws, setHighlightedDraws] = useState([]);
    const [goldenAnk, setGoldenAnk] = useState('');
    const [finalAnkArray, setFinalAnkArray] = useState([]);
    const [domainName, setDomainName] = useState('');

    const [pattiNumbersList, setPattiNumbersList] = useState([]);


    useEffect(() => {
        // Combine both config fetches into one
        const initializeApp = async () => {
            await fetchConfig();
            await fetchConfig1();
        };
        initializeApp();
    }, []); // This will run once on mount

    useEffect(() => {
        // Only fetch draws if we have config loaded
        if (Object.keys(config).length > 0) {
            fetchDraws();
        }
    }, [config]); // Only re-run if config changes

    useEffect(() => {
        if (draws.length > 0) {
            fetchTodaysDraws();
        }
    }, [draws]);

    useEffect(() => {
        if (todaysDraws.length > 0) {
            fetchUpcomingDraws();
        }
    }, [todaysDraws]);

    useEffect(() => {
        if (config && mumbaiPatternDraws.length > 0) {
            getTopSixMumbaiDraws();
        }
    }, [config, mumbaiPatternDraws]);

    useEffect(() => {
        fetchHighlightedDraws();
    }, []);

    useEffect(() => {
        // Get the current domain name
        const hostname = window.location.hostname;
        setDomainName(hostname);
    }, []);

    // Function to format domain name according to requirements
    const formatDomainName = (domain) => {
        // Define mapping for specific domains
        const domainMapping = {
            'lotterymatka.com': 'lottery matka',
            'dpbossbombay.in': 'dpboss bombay',
            'dpbossgolden.in': 'dpboss golden',
            'lotterybazar.in': 'lottery bazar',
            'lotterymatka.in': 'lottery matka'
        };

        // Check if domain is in the mapping
        if (domainMapping[domain]) {
            return domainMapping[domain];
        }

        // For other domains, remove TLD and split by any non-alphanumeric character
        const domainWithoutTLD = domain.split('.')[0];

        // Try to split the domain into words based on common patterns
        let words;
        if (domainWithoutTLD.includes('-')) {
            words = domainWithoutTLD.split('-');
        } else if (domainWithoutTLD.match(/[A-Z]/)) {
            // Split by capital letters
            words = domainWithoutTLD.split(/(?=[A-Z])/);
        } else {
            // Try to identify word boundaries in the domain
            // This is a simple approach - for more complex domains, additional logic may be needed
            words = domainWithoutTLD.match(/[a-z]+/g) || [domainWithoutTLD];
        }

        // If we have more than 2 words, combine all but the first into the second word
        if (words.length > 2) {
            words = [words[0], words.slice(1).join(' ')];
        } else if (words.length === 1) {
            // If only one word, use it as is
            words = [words[0], ''];
        }

        // Ensure first letter of each word is capitalized
        words = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

        return words.join(' ').trim();
    };

    useEffect(() => {
        const fetchAnkData = async () => {
            try {
                const configDocRef = doc(db, 'config', 'dpanna-main');
                const configDocSnapshot = await getDoc(configDocRef);

                if (configDocSnapshot.exists()) {
                    const configData = configDocSnapshot.data();
                    setGoldenAnk(configData.golden_ank || '');
                    setFinalAnkArray(configData.final_ank || []);
                }
            } catch (error) {
                console.error('Error fetching ank data:', error);
            }
        };

        fetchAnkData();
    }, []);

    const convertStringToTime = (inputString) => {
        const [hours, minutes] = inputString.split(":").map(Number);
        if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
            throw new Error("Invalid time values");
        }
        const date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date;
    };

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const generateDatesToFetch = (currentDate, daysBehind, daysAhead) => {
        const dates = [];
        for (let i = daysBehind; i >= -daysAhead; i--) {
            const date = new Date(currentDate);
            date.setDate(currentDate.getDate() - i);
            dates.push(formatDate(date));
        }
        return dates;
    };

    const fetchDraws = async () => {
        try {

            const currentDate = new Date();
            const datesToFetch = generateDatesToFetch(currentDate, 1, 1).map(date => date.replace(/-/g, "/"));

            const response = await fetch("https://dp-anna-api.web.app/api/fetchDraws1");
            const allDrawsData = await response.json().then(data => data.data);
// Fetch the data from the API
            const responsePatternDraws = await fetch("https://dp-anna-api.web.app/api/fetchPatternDraws1");
            const patternDrawsDataResponse = (await responsePatternDraws.json()).data;
// Destructure the arrays from the response
            const { mumbaiPatternDraws, delhiPatternDraws } = patternDrawsDataResponse;
// Process the Mumbai draws data by filtering and sorting
            const mumbaiPatternDrawsData = mumbaiPatternDraws
                .filter(draw => config.draws_to_show.includes(draw.id))
                .sort((a, b) => convertStringToTime(a.startTime) - convertStringToTime(b.startTime));
// Process the Delhi draws data by sorting
            const delhiPatternDrawsData = delhiPatternDraws
                .sort((a, b) => convertStringToTime(a.startTime) - convertStringToTime(b.startTime));

            setMumbaiPatternDraws(mumbaiPatternDrawsData);
            setDelhiPatternDraws(delhiPatternDrawsData);

            const mumbaiDraws = allDrawsData.filter(draw => draw.pattern === "mumbaiPattern").sort((a, b) =>
                convertStringToTime(a.startTime) - convertStringToTime(b.startTime)
            );

            const delhiDraws = allDrawsData.filter(draw => draw.pattern === "delhiPattern").sort((a, b) =>
                convertStringToTime(a.startTime) - convertStringToTime(b.startTime)
            );

            const fetchedDraws = datesToFetch.map(date => ({
                date,
                mumbaiDraws: mumbaiDraws.filter(draw => draw.date === date),
                delhiDraws: delhiDraws.filter(draw => draw.date === date)
            })).reverse();

            setDraws(fetchedDraws);

        } catch (error) {
            console.error('Error fetching draws:', error);
        }
    };

    const getTopSixMumbaiDraws = () => {
        if (config && config.top_draws_to_show && Array.isArray(config.top_draws_to_show)) {
            const drawIds = config.top_draws_to_show;
            const topDraws = drawIds
                .map(id => mumbaiPatternDraws.find(draw => draw.id === id))
                .filter(Boolean)
                .sort((a, b) => convertStringToTime(a.startTime) - convertStringToTime(b.startTime));
            console.log("Top Draws:", topDraws);
            setTopSixMumbaiDraws(topDraws);
        } else {
            console.error("Invalid config or top_draws_to_show is not an array");
        }
    };

    const fetchUpcomingDraws = () => {
        if (todaysDraws.length) {
            const currentTime = new Date();
            const timeThreshold = 30 * 60 * 1000; // 30 minutes

            const filterUpcomingDraws = (draws) => draws.filter(draw => {
                const startTime = convertStringToTime(draw.startTime);
                const closingTime = convertStringToTime(draw.closingTime);
                const openingDifference = startTime - currentTime;
                const closingDifference = closingTime - currentTime;

                return (openingDifference <= timeThreshold && openingDifference > -timeThreshold) ||
                    (closingDifference <= timeThreshold && closingDifference > -timeThreshold);
            }).map(draw => ({
                ...draw,
                selectedDraw: convertStringToTime(draw.startTime) - currentTime <= timeThreshold ? "opening" : "closing"
            }));

            const uniqueDraws = (draws) => [...new Map(draws.map(draw => [draw.id, draw])).values()];

            setUpcomingDraws(uniqueDraws(filterUpcomingDraws(mumbaiPatternDraws)));
        }
    };

    const fetchTodaysDraws = () => {
        const currentDate = new Date();
        const formattedCurrentDate = formatDate(currentDate).replace(/-/g, "/");
        const formattedYesterdayDate = formatDate(new Date(currentDate.setDate(currentDate.getDate() - 1))).replace(/-/g, "/");

        let currentDayDraws = draws.find(draw => draw.date === formattedCurrentDate)?.mumbaiDraws || [];
        if (!currentDayDraws.length) {
            currentDayDraws = draws.find(draw => draw.date === formattedYesterdayDate)?.mumbaiDraws || [];
        }

        let currentDayDrawsDelhi = draws.find(draw => draw.date === formattedCurrentDate)?.delhiDraws || [];
        if (!currentDayDrawsDelhi.length) {
            currentDayDrawsDelhi = draws.find(draw => draw.date === formattedYesterdayDate)?.delhiDraws || [];
        }

        currentDayDraws.sort((a, b) => convertStringToTime(a.startTime) - convertStringToTime(b.startTime));
        setTodaysDraws([{ date: formattedCurrentDate, mumbaiDraws: currentDayDraws, delhiDraws: currentDayDrawsDelhi }]);
    };

    const mapKeys = (obj) => {
        const newObj = {};
        for (const key in obj) {
            const newKey = key.replace(/-/g, '_');
            if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                newObj[newKey] = mapKeys(obj[key]);
            } else {
                newObj[newKey] = obj[key];
            }
        }
        return newObj;
    };
    const fetchConfig = async () => {
        try {
            const configDocSnapshot = await getDoc(doc(db, 'config', 'dpanna-main'));
            if (configDocSnapshot.exists()) {
                const configData = configDocSnapshot.data();
                const mappedConfigData = mapKeys(configData);

                // Transform the whatsAppNumbers map to an array of objects
                const numbersList = Object.entries(mappedConfigData.whatsAppNumbers).map(([name, number]) => ({
                    name,
                    number
                }));

                setWhatsAppNumbersList(numbersList);
                setConfig(mappedConfigData);
            } else {
                console.log('Document does not exist');
            }
        } catch (error) {
            console.error('Error fetching config:', error);
        }
    };

    const fetchConfig1 = async () => {
        try {
            const configDocSnapshot = await getDoc(doc(db, 'config', 'dpanna-golden-news'));
            if (configDocSnapshot.exists()) {
                const configData = configDocSnapshot.data();
                const mappedConfigData = mapKeys(configData);

                const luckyNumbersList = Object.entries(mappedConfigData.luckyNumbers).map(([title, content]) => ({
                    title,
                    content
                }))

                const pattiNumbersList = Object.entries(mappedConfigData.multipleNumbers || {}).map(([title, content]) => ({
                    title,
                    content
                }));

                const tripledPattiNumbersList = [...pattiNumbersList, ...pattiNumbersList];

                setPattiNumbersList(tripledPattiNumbersList);
                setLuckyNumbersList(luckyNumbersList);
            } else {
                console.log('Document does not exist');
            }
        } catch (error) {
            console.error('Error fetching config:', error);
        }
    };

    const fetchHighlightedDraws = async () => {
        try {
            const configDocRef = doc(db, 'config', 'dpanna-main');
            const configDocSnapshot = await getDoc(configDocRef);

            if (configDocSnapshot.exists()) {
                const configData = configDocSnapshot.data();
                const highlightedDrawsArray = configData['highlightedDraws'] || [];
                setHighlightedDraws(highlightedDrawsArray);
            }
        } catch (error) {
            console.error('Error fetching highlighted draws:', error);
        }
    };

    const refreshData = async () => {
        setLoading(true);
        await fetchDraws();
        fetchTodaysDraws();
        getTopSixMumbaiDraws();
        fetchUpcomingDraws();
        setLoading(false);
    };

    const LoadingSpinner = () => {
        return (
            <div className="flex justify-center backdrop-blur-lg backdrop-saturate-150 items-center z-50 fixed w-screen bg-black/30 h-screen">
                <div className="animate-spin rounded-full h-28 w-28 border-t-4 border-b-4 border-yellow-400"></div>
            </div>
        );
    };

    // Create schema for homepage
    const homeSchema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "DPANNA",
        "url": "https://dpanna.in",
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://dpanna.in/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
        }
    };


    return (
        <>
            <SEO
                title="Golden Group Results & Lucky Numbers"
                description="Get the latest Golden Group results, lucky numbers, and daily updates at DPANNA - your trusted source for all updates."
                keywords="DPANNA, Golden Group results, today's lucky number, Mumbai bazaar, Delhi bazaar"
                schema={homeSchema}
            />
            {loading && <LoadingSpinner />}
            <div className="flex flex-col items-center bg-[#ffcc99] min-h-screen text-[#00094d]">

                <div className={"px-2 flex w-full"}>
                    <div className={"text-3xl sm:text-5xl md:text-6xl font-bold flex italic border-2 border-red-700 p-2 sm:p-4 mt-2 mb-2 rounded-2xl w-full text-center justify-center items-center overflow-hidden whitespace-nowrap"}>
                        {domainName ? (
                            (() => {
                                const formattedDomain = formatDomainName(domainName);
                                const words = formattedDomain.split(' ');
                                const firstWord = words[0] || '';
                                const secondWord = words.slice(1).join(' ') || '';

                                return (
                                    <>
                                        <p className={"text-pink-600 capitalize"}>{firstWord}</p>
                                        <p className={"text-[#00094d] capitalize"}>{secondWord}</p>
                                    </>
                                );
                            })()
                        ) : (
                            <>
                                <p className={"text-pink-600"}>DP</p>
                                <div>
                                    Anna.com
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className={"px-2 w-full flex"}>
                    {/* A Rectangular Box with image on the left and on the right this text  !!welcome to DPANNA international!! on next line below it !!Satta Matka Fast Result!!*/}
                    <div className="px-2 mb-2 w-full max-w-4xl mx-auto border-2 border-red-700 rounded-2xl">
                        <div className="rounded-xl relative overflow-hidden">
                            <div className="flex sm:flex-row items-center p-1 relative z-10">
                                <div className="w-32 sm:w-40 flex-shrink-0 mb-4 sm:mb-0">
                                    <img
                                        src={require("../Images/ganesh-lakshmi_1508345551.avif")}
                                        alt="Ganesh Lakshmi"
                                        className="w-full h-auto rounded-lg border-2 "
                                    />
                                </div>
                                <div className="flex-grow text-center text-blue-950 italic">
                                    <div className="text-lg font-bold  tracking-wider mb-2 leading-5">
                                        !! Welcome to DPANNA International !! Satta Matka Fast Result !!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Matka keywords banner */}
                <div className="px-2 mb-2 w-full text-center">
                    <p className="italic border-2 border-red-700 px-4 rounded-2xl leading-4 text-sm">
                        <span className="font-bold italic">DpAnna is the No. 1 Matka Site welcomes you full-heartedly. Here below you can find the perfect guess by the top guesser along with the Fast Matka Result too. Aaj Ka Satta Kalyan Fix Single Jodi free update here you find top Matka Market of India Kalyan Main Milan Rajdhani kalyan Matka Tips fast Matka Result kalyan Main Rajdhani Matka Chart Matka Guessing by DpAnna By App Best Matka Site By DpAnna</span>
                    </p>
                </div>

                {/* Lucky Numbers Section */}
                {luckyNumbersList.length > 0 && (
                    <div className="px-2 mb-2 w-full">
                        <h1 className="text-center text-xl sm:text-2xl md:text-5xl font-bold text-[#ffff00]
                            inline-block px-4 sm:px-8 py-2 rounded-xl bg-[#5b3410] mx-auto">
                            Today's Lucky Number
                        </h1>
                        <div className="wrapper w-full mt-4">
                            <div className="marquee">
                                <MarqueeGroup isReverse={true} arrayOfObjects={luckyNumbersList}/>
                                <MarqueeGroup isReverse={true} arrayOfObjects={luckyNumbersList}/>
                            </div>
                        </div>
                    </div>
                )}

                {/* Patti Numbers Section */}
                {pattiNumbersList.length > 0 && (
                    <div className="px-2 mb-2 w-full ">
                        <div className="wrapper w-full">
                            <div className="marquee">
                                <PattiMarqueeGroup isReverse={false} arrayOfObjects={pattiNumbersList} />
                                <PattiMarqueeGroup isReverse={false} arrayOfObjects={pattiNumbersList} />
                            </div>
                        </div>
                    </div>
                )}

                <div className={"flex px-2 mb-2 w-full text-center items-center justify-center"}>
                    <Link to={"/form"} className={"bg-[#011E76] text-white text-xl font-extrabold rounded-2xl px-4 py-2 border-2 border-red-700"}>
                        हमसे संपर्क करने के लिए ➡️ यहाँ क्लिक करें
                    </Link>
                </div>

                {/* Golden Ank and Final Ank Section */}
                <div className="flex flex-col mb-2 w-full rounded-2xl">
                    <div className="flex flex-col italic border-2 border-red-700 mx-2 px-1 rounded-2xl">
                        <h3 className="flex text-center items-center justify-center text-2xl font-bold text-white italic bg-[#FF00A2] border-2 border-white rounded-xl">
                            Today's Lucky Number
                        </h3>
                        {/* Golden Ank */}
                        <div className={"flex"}>
                            <div className="flex flex-col items-center h-full pl-2">
                                <h3 className="text-xl sm:text-2xl font-bold mb-2 text-[#011599]">Golden Ank</h3>
                                <div className="text-xl sm:text-6xl font-extrabold text-[##000B65]">{goldenAnk}</div>
                            </div>
                            <div className={"h-20 w-px bg-red-800 ml-4"}>

                            </div>
                            {/* Final Ank */}
                            <div className="flex-grow relative overflow-hidden">
                                <h3 className="absolute top-0 left-0 w-full text-center text-xl sm:text-2xl font-bold text-[#011599] bg-[#ffcc99] z-10">
                                    Final Ank
                                </h3>
                                <div
                                    className="absolute inset-0 flex flex-col items-center justify-center overflow-hidden">
                                    <div className="marquee-vertical">
                                        {finalAnkArray.map((item, index) => (
                                            <div key={index}
                                                 className="text-lg sm:text-4xl font-bold text-[##000B65] leading-2">
                                                {item}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Live Result Section */}
                <div className="px-2 mb-2 live-result w-full text-center max-w-6xl">
                    <h3 className="text-2xl font-bold text-white italic bg-[#FF00A2] border-2 border-white rounded-xl">
                        Live Result
                    </h3>
                    {upcomingDraws.length > 0 && (
                        <div className="rounded-2xl overflow-hidden backdrop-blur-md border-[3px] border-[#AA00C0]">
                            {upcomingDraws.map((draw, index) => (
                                <div
                                    key={draw.id}
                                    className={`py-1 relative transition-all duration-300 border-b-[1px] border-[#FF0918] leading-7`}
                                >
                                    <div className="flex flex-col items-center z-10">
                                        <h3 className="text-[24px] sm:text-[27px] text-indigo-900 italic font-extrabold leading-tight">
                                            {draw.drawName}
                                        </h3>
                                        <div
                                            className="text-[26px] sm:text-[30px] font-extrabold italic z-10 leading-tight">
                                            {draw.selectedPattern === "mumbai-pattern" ? (
                                                (() => {
                                                    const m = todaysDraws[0]?.mumbaiDraws.find(d => d.idDrawName === draw.id);
                                                    if (m) {
                                                        const full = getFullPatti(m.openRoundPatti, m.closeRoundPatti);
                                                        return (
                                                            <span className="inline-block text-transparent bg-gradient-to-b from-purple-900 to-pink-900 bg-clip-text drop-shadow-[0_0_8px_rgba(168,85,247,0.5)]">
                        {full || `${m.openRoundPatti}x-xxx`}
                      </span>
                                                        );
                                                    }
                                                    return <span className="text-[#a08269]/70">xxx-xx-xxx</span>;
                                                })()
                                            ) : (
                                                (() => {
                                                    const d = todaysDraws[0]?.delhiDraws.find(x => x.idDrawName === draw.id);
                                                    return d?.number ? (
                                                        <span className="inline-block text-transparent bg-gradient-to-b from-purple-900 to-pink-900 bg-clip-text drop-shadow-[0_0_8px_rgba(168,85,247,0.5)]">
                      {d.number}
                    </span>
                                                    ) : (
                                                        <span className="text-[#a08269]/70">xx</span>
                                                    );
                                                })()
                                            )}
                                        </div>
                                        {/*<div className="flex gap-6 text-[16px] sm:text-[20px] font-extrabold text-blue-900 italic">*/}
                                        {/*    <div>{twentyFourHourToTwelveHourCovert(draw.startTime)}</div>*/}
                                        {/*    <div>{twentyFourHourToTwelveHourCovert(draw.closingTime)}</div>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Separator */}
                {/*<div className="w-full h-[2px] bg-amber-950/30 my-4"></div>*/}

                {/* App Download Button */}
                <div className="px-2 mb-2 w-full max-w-md mx-auto italic">
                    <div className="bg-[#B90000] rounded-xl relative overflow-hidden transition-all duration-300 hover:bg-[#724623]">
                        <p className={"flex text-center text-lg font-bold text-white tracking-wider px-4 pt-2"}>
                            अब सभी मटका बाजार खेलो ऑनलाइन ऐप पर रोज खेलो रोज कमाओ अभी डाउनलोड करो
                        </p>
                        <a href={`https://drive.google.com/file/d/1zItpe0_4QOp2j1SSGF73Pn8elPoEx2HZ/view`}
                           target="_blank"
                           rel="noopener noreferrer"
                           className="flex flex-col items-center justify-center  space-y-1 relative z-10">
                            <div className="text-xl font-black text-white tracking-wider bg-[#011E76] px-3 py-1 rounded-full border-2 border-white shadow-lg transition-all duration-300 hover:bg-[#011E76]">
                                💰 Online Matka Play 💰
                            </div>
                            <p className="text-white text-lg font-bold text-center">
                                Back Again With New Features - 100% Trusted Fast Payin - Instant Withdraw
                            </p>
                        </a>
                    </div>
                </div>

                {/* Separator */}
                {/* <div className="w-full h-[2px] bg-amber-950/30 my-4"></div> */}

                {/* Today's Draw Header */}
                <div className={"px-2 mb-2"}>
                    <div className="w-full flex flex-col font-bold justify-center text-xl sm:text-2xl md:text-3xl bg-[#FF00A2] border-2 border-white py-1 rounded-xl relative overflow-hidden">
                        <span className="relative z-10 italic text-center text-white font-bold leading-5 px-2"> WORLD ME SABSE FAST SATTA MATKA RESULT</span>
                    </div>
                </div>

                {/* Today's Result Section */}
                <div className="px-2 mb-2 todays-result w-full text-center max-w-6xl">
                    {mumbaiPatternDraws.length > 0 && (
                        <div className="rounded-2xl overflow-hidden backdrop-blur-md border-[3px] border-[#AA00C0]">
                            {mumbaiPatternDraws.map((draw, index) => {
                                const isHighlighted = highlightedDraws.includes(draw.id);
                                return (
                                    <div key={draw.id}
                                         className={` relative ${
                                             index !== 0 ? '' : ''
                                         }transition-all duration-300 border-b-[1px] border-[#FF0918] leading-7`}>
                                        {isHighlighted && (
                                            <>
                                                <div className="absolute top-0 left-0 w-full h-full bg-[#ffd700]"></div>
                                            </>
                                        )}
                                        <div className="flex flex-col items-center">
                                            <h3 className={`text-[23px] sm:text-[27px] text-indigo-900 italic font-bold z-10`}>
                                                {draw.drawName}
                                            </h3>
                                            <div className="text-[24px] sm:text-[30px] font-extrabold z-10 italic">
                                                {todaysDraws.length > 0 && todaysDraws[0].mumbaiDraws.find(todaysDraw => todaysDraw.idDrawName === draw.id) ? (
                                                    <span className="inline-block text-transparent bg-gradient-to-b from-purple-900 to-pink-900 bg-clip-text drop-shadow-[0_0_8px_rgba(168,85,247,0.5)]" style={{

                                                        WebkitBackgroundClip: 'text'
                                                    }}>
                                                        {getFullPatti(
                                                            todaysDraws[0].mumbaiDraws.find(todaysDraw => todaysDraw.idDrawName === draw.id).openRoundPatti,
                                                            todaysDraws[0].mumbaiDraws.find(todaysDraw => todaysDraw.idDrawName === draw.id).closeRoundPatti
                                                        )}
                                                    </span>
                                                ) : (
                                                    <span className="text-[#a08269]/70">--</span>
                                                )}
                                            </div>
                                            <div className="flex gap-6 text-[16px] sm:text-[20px] font-extrabold text-blue-900 z-10 italic">
                                                <div>{twentyFourHourToTwelveHourCovert(draw.startTime)}</div>
                                                <div>{twentyFourHourToTwelveHourCovert(draw.closingTime)}</div>
                                            </div>
                                        </div>
                                        <Link to={`/chart/${draw.id}/false/m`}
                                              className="absolute top-7 sm:top-1/2 right-2 sm:right-4 sm:-translate-y-1/2 z-10
                                                    bg-blue-900 text-white text-sm sm:text-base font-bold px-2 sm:px-4 py-1 sm:py-2 rounded-lg
                                                    hover:bg-blue-700 transition-colors duration-200 shadow-md
                                                    flex items-center justify-center">
                                            Chart
                                        </Link>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
                {/* SEO Keywords */}
                <SEOKeywords />
            </div>

            {/* Refresh Button with Flat Styling */}
            <button
                className="fixed bottom-4 right-4 text-2xl text-white font-bold bg-blue-800 rounded-xl px-4 py-2 transition-all duration-300 "
                onClick={() => {
                    refreshData()
                }}
            >
                Refresh
            </button>

            {/* Telegram Button with Flat Styling */}

            <style>
                {`
                .marquee-vertical {
                    display: flex;
                    flex-direction: column;
                    animation: scrollUp 10s linear infinite;
                }

                @keyframes scrollUp {
                    0% {
                        transform: translateY(100%);
                    }
                    100% {
                        transform: translateY(-100%);
                    }
                }
                `}
            </style>
        </>
    );
}

export const twentyFourHourToTwelveHourCovert = (string) => {
    const [hours, minutes] = string.split(":");
    const formattedHours = hours.padStart(2, '0');
    const formattedMinutes = minutes.padStart(2, '0');
    const period = formattedHours >= 12 ? 'PM' : 'AM';
    const displayHours = formattedHours > 12 ? formattedHours - 12 : formattedHours;
    return `${displayHours}:${formattedMinutes} ${period}`;
}



export const getFullPatti = (open, close) => {
    const openNumber = parseInt(open, 10);
    const closeNumber = parseInt(close, 10);

    const openDigits = openNumber.toString().split('').map(Number);
    const closeDigits = closeNumber.toString().split('').map(Number);

    const openSum = openDigits.reduce((a, b) => a + b, 0);
    const closeSum = closeDigits.reduce((a, b) => a + b, 0);

    const openLastDigit = openSum.toString().slice(-1);
    const closeLastDigit = closeSum.toString().slice(-1);

    if (!close) {
        return `${open} - ${openLastDigit}x - xxx`;
    } else if (open && close) {
        return `${open} - ${openLastDigit}${closeLastDigit} - ${close}`;
    } else {
        return '';
    }
}

const MarqueeGroup = ({ isReverse, arrayOfObjects }) => (
    <div className={`marquee__group ${isReverse ? 'marquee--reverse' : ''}`}>
        {arrayOfObjects.map((item, index) => (
            <div key={index} className="sm:p-3 my-8 sm:my-16 rounded-xl bg-[#444444] relative overflow-hidden">
                <div className="absolute inset-0 bg-[#ffcc99]/5 backdrop-blur-sm rounded-xl"></div>
                <div className="relative z-10">
                    <div className="text-2xl sm:text-4xl font-semibold px-5 pt-2 text-[#ffff00]">{item.title}</div>
                    <div className="text-center text-2xl sm:text-4xl font-bold text-[#ffcc99] px-4 pb-2" style={{letterSpacing: "6px"}}>{item.content}</div>
                </div>
            </div>
        ))}
    </div>
);

const PattiMarqueeGroup = ({ isReverse, arrayOfObjects }) => (
    <div className={`marquee__group ${isReverse ? 'marquee--reverse' : ''}`}>
        {arrayOfObjects.map((item, index) => (
            <div key={index} className="p-4 my-8 rounded-xl bg-[#444444] relative overflow-hidden">
                <div className="absolute inset-0 bg-[#ffcc99]/5 backdrop-blur-sm rounded-xl"></div>
                <div className="relative z-10">
                    <div className="text-xl sm:text-2xl font-semibold text-[#ffff00] mb-2">{item.title}</div>
                    <div className="grid grid-cols-3 gap-2">
                        {item.content.split(',').map((number, idx) => (
                            <div key={idx} className="text-center text-lg sm:text-xl font-bold text-[#ffcc99] bg-[#00094d] rounded-lg p-2 transition-colors duration-200 hover:bg-[#001070]">
                                {number.trim()}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        ))}
    </div>
);
